import { Component, OnInit, } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MeAvise } from '@app/models/me-avise';
import { ProcessoMovimentacaoService } from '@app/services/processo-movimentacao.service';
import { TipoMovimentacao } from '@app/models/processo-movimentacao';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ProcessoService } from '@app/services/processo.service';

@Component({
  selector: 'app-movimentacao-prazo-form',
  templateUrl: './movimentacao-prazo-form.component.html'
})
export class MovimentacaoPrazoFormComponent implements OnInit {

  titulo: string;
  titulo2: string;
  meAvise: MeAvise[] = [];

  lstErros: string[];
  lstUsuarios: IdDescricao[];
  lstMeAviseTipo: IdDescricao[];
  editar = false;
  tipo: string;
  tipoMovimentacao: TipoMovimentacao;
  descricaoMovimentacao;

  processoId: number;
  movimentacaoId: number;
  processoArquivado: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private processoMovimentacaoService: ProcessoMovimentacaoService,
    private processoService: ProcessoService,
    private consultasService: ConsultasService,
  ) {


  }

  ngOnInit() {
    this.consultasService.consultar('USUARIO').toPromise().then(data => this.lstUsuarios = data);
    this.consultasService.consultar('MEAVISETIPO').toPromise().then(data => this.lstMeAviseTipo = data);
    this.meAvise.push(new MeAvise());

    this.route.parent.params.subscribe(
      (params: any) => {
        this.processoId = params['id'];
      });
    this.route.params.subscribe(params => {
      this.tipo = params['tipo'];
      switch (this.tipo.toUpperCase()) {
        case 'ADMINISTRATIVA':
          this.titulo = 'Movimentação Administrativa';
          this.tipoMovimentacao = TipoMovimentacao.ADMINISTRATIVA;
          break;
        case 'EXECUCAO-PROVISORIA':
          this.titulo = 'Movimentação Execução Provisória';
          this.tipoMovimentacao = TipoMovimentacao.EXECUCAO_PROVISORIA;
          break;
        case 'JUDICIAL':
          this.titulo = 'Movimentação Judicial';
          this.tipoMovimentacao = TipoMovimentacao.JUDICIAL;
          break;
        case 'ATO-PROCESSUAL':
          this.titulo = 'Movimentação Ato Processual';
          this.tipoMovimentacao = TipoMovimentacao.ATO_PROCESSUAL;
          break;
        default:
          this.tipoMovimentacao = null;
      }
    });

    this.route.params.subscribe(params => {
      const id = params['prazoid'];
      this.editar = Boolean(id);
      this.titulo2 = this.editar ? 'Editar Prazo' : 'Novo Prazo';

      if (!id) {
        this.movimentacaoId = params['movid'];
      } else {
        this.editar = true;
        this.processoService.movimentacaoObterMeAvise(id)
          .subscribe(
            data => {
              this.meAvise = [];
              data.Data = data.Data.split('T')[0];
              data.Prazo = data.Prazo.split('T')[0];
              data.PrazoFatal = data.PrazoFatal.split('T')[0];
              data.PrazoInterno = data.PrazoInterno.split('T')[0];

              this.meAvise.push(data);
              this.buscarMovimentacao();
            },
            data => this.router.navigate(['./processos/buscar-processos']));
      }
    });

    if (!this.editar) {
      this.meAvise[0].ProcessoId = this.processoId;
      this.meAvise[0].ProcessoMovimentacaoId = this.movimentacaoId;
      this.buscarMovimentacao();
    }

  }

  onSubmit() {
    const meAvise = this.meAvise[0];
    this.processoService.movimentacaoGravarMeAvise(meAvise).subscribe(
      () => window.history.go(-1),
      (data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
      }
    );
  }


  // adicionar() {

  // }

  // atualizar() {
  //     let meAvise = this.meAvise[0];
  //     this.processoMovimentacaoService.alterarMeAvise(meAvise).subscribe(
  //         () => window.history.go(-1),
  //         (data: any) => {
  //             if (data.error)
  //                 this.lstErros = data.error.errors;
  //         }
  //     )
  // }

  buscarMovimentacao() {
    const meAvise = this.meAvise[0];
    this.processoMovimentacaoService.obterDescricaoMovimentacaoPorId(meAvise.ProcessoMovimentacaoId).subscribe(
      (data) => { this.descricaoMovimentacao = data; },

    );
  }
}
